<app-modal-frame
  [headerText]="DISPLAY_CONSTANTS.HEADER"
  [rightButton]="{
    text: DISPLAY_CONSTANTS.SAVE,
    disable: !submitButtonVisible,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitRightClick)="onSubmit()"
  (emitExit)="onClose()"
>
  <app-two-column-form
    [assignedHeaderText]="DISPLAY_CONSTANTS.ASSIGNED_HEADER_TEXT"
    [assignedData]="assignedRoutesData"
    [availableHeaderText]="DISPLAY_CONSTANTS.AVAILABLE_HEADER_TEXT"
    [availableData]="availableRoutesData"
    (canSubmitForm)="handleUpdateSubmit($event)"
    (updateAssignedValues)="handleUpdateAssignedValues($event)"
  ></app-two-column-form>
</app-modal-frame>
